<template>
  <div class="w-11/12 mx-auto pt-10" :class="{ 'iframe-mode': isInIframe }">
    <div class="text-zt-xl" :class="primaryTextClass">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <button class="h-8 w-8 back-button" @click="goBack()" v-on="on" data-vs-button="toLicenceManager">
            <zt-icon name="arrow-left" class="pb-2 mt-1 pr-1" />
          </button>
        </template>
        <span>{{ $t("message.LicensesManager.goBack") }}</span>
      </v-tooltip>
      <span class="ml-1">{{ $t('message.LicensesManager.balances.title') }}</span>
    </div>
    <div class="mt-3 flex flex-wrap w-full pb-4">
      <div class="w-3/12 pr-4">
        <v-card>
          <v-card-text>
            <div class="w-full">
              <div>
                <v-autocomplete
                  v-model="userSelected"
                  :items="items"
                  :loading="usersLoading"
                  :search-input.sync="searchUsers"
                  cache-items
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="id"
                  :label="$t('message.LicensesManager.search.user')"
                  :hint="$t('message.LicensesManager.search.userHint')"
                  persistent-hint
                  return-object
                  outline
                  :color="primaryColor"
                  clearable
                  data-vs-autocomplete="userSelected"
                ></v-autocomplete>
              </div>
              <div>
                <v-select
                  class="selectLicenseProperty"
                  item-text="nombre"
                  item-value="id"
                  :items="licenseTypes"
                  v-model="licenseTypeSelected"
                  return-object
                  :label="$t('message.LicensesManager.search.type')"
                  outline
                  :color="primaryColor"
                  clearable
                  data-vs-select="licenceType"
                ></v-select>
              </div>
              <div>
                <v-select
                  class="selectLicenseProperty"
                  item-text="value"
                  item-value="id"
                  :items="estadosUsuario"
                  :value="estadosUsuario.id"
                  v-model="estadoUsuarioSelected"
                  return-object
                  :label="$t('message.LicensesManager.search.userStatus')"
                  outline
                  :color="primaryColor"
                  data-vs-select="userStatus"
                ></v-select>
              </div>
              <div>
                <v-combobox
                  class="selectLicenseProperty"
                  :items="yearsRange"
                  :value="periodo"
                  v-model="periodo"
                  :label="$t('message.LicensesManager.balances.period')"
                  outline
                  :color="primaryColor"
                  type="number"
                  data-vs-combobox="periodo"
                ></v-combobox>
              </div>
              <div class="w-2/5 mx-auto">
                <zt-button class="w-full" icon="search-outline" @click="searchButton" data-vs-button="search">{{ $t('message.LicensesManager.search.search') }}</zt-button>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="w-9/12">
        <template v-if="totalResults === 0">
          <div class="bg-white w-full pt-16 pb-32">
            <div class="mx-auto w-64">
              <graphic-base height="196" width="207" :viewBox="'0 0 196 207'">
                <EmptyStateLicensesSearch />
              </graphic-base>
            </div>
            <div class="mx-auto mt-8 w-full text-center">
              <span class="text-zt-lg" :class="primaryTextClass">
                {{ $t('message.LicensesManager.search.empty') }}
              </span>
            </div>
          </div>
        </template>
        <template v-else>
          <BalancesTable />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import Users from '@/apiClient/Users'
import { mapGetters } from "vuex"
import moment from 'moment'
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import EmptyStateLicensesSearch from '@/components/commons/Illustrations/graphicSVG/licenseSearchEmpty'
import BalancesTable from './BalancesTable'
import { isEmpty } from 'lodash'

export default {
  inject: ['state', 'mutations'],
  components: {
    graphicBase,
    EmptyStateLicensesSearch,
    BalancesTable
  },
  data() {
    return {
      licenses: Licenses,
      users: Users,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 8,
        sortBy: null,
        totalItems: 0
      },
      usersList: [],
      usersLoading: false,
      userSelected: {
        id: 0
      },
      searchUsers: null,
      licenseTypes: [],
      licenseTypeSelected: '',
      estadosUsuario: [
        {id: "1", value: this.$t('message.LicensesManager.search.userStatusActive')},
        {id: "3", value: this.$t('message.LicensesManager.search.userStatusUnactive')},
        {id: null, value: this.$t('message.LicensesManager.search.all')}
      ],
      estadoUsuarioSelected: {id:"1", value: this.$t('message.LicensesManager.search.userStatusActive')},
      periodo: ''
    }
  },
  created() {
    this.licenses = new Licenses()
    this.users = new Users()
    this.licenses.getLicenseTypesManager().then(res => {
      this.licenseTypes = res.data.data
    })
  },
  computed: {
    yearsRange(){
      let startYear = 2009
      let twoYearsFromNow = moment().add(2, 'years').format('YYYY')
      let years = []
      while (startYear <= twoYearsFromNow) {
        years.push(twoYearsFromNow--);
      }
      return years
    },
    totalResults() {
      return this.state.total
    },
    items() {
      return this.usersList.map(entry => {
        let fullName = `${entry.name} ${entry.last_name} (${entry.laborId})`;
        const name =
          fullName.length > this.descriptionLimit
            ? fullName.slice(0, this.descriptionLimit) + "..."
            : fullName;

        return Object.assign({}, entry, { name });
      });
    },
    ...mapGetters({
      locale: 'getLocaleForDatepicker'
    }),
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3';
    }
  },
  watch: {
    searchUsers(val) {
      if(val && val.length > 2){
        if (this.usersLoading) return;
        this.usersLoading = true;
        this.licenses.searchEmployeesAssigned(val, 0)
          .then(res => {
            this.usersList = res.data.data;
          })
          .catch(err => {})
          .finally(() => (this.usersLoading = false));
      }
    }
  },
  methods: {
    searchButton(){
      if(isEmpty(this.state.pagination)){
        this.mutations.setPagination(this.pagination)
      }

      let filters = {
        userId: (this.userSelected) ? this.userSelected.id : null,
        licenseTypeId: (this.licenseTypeSelected)? this.licenseTypeSelected.id : null,
        periodo: this.periodo,
        estadoUsuarioId: this.estadoUsuarioSelected !== null ? this.estadoUsuarioSelected.id : null
      }
      this.mutations.setFilters(filters)
      this.search()
    },
    search(){
      this.mutations.setPagination(this.pagination)
      this.licenses
        .searchBalances(this.state.filters, this.state.pagination.rowsPerPage, this.state.pagination.page)
        .then(response => {
          this.mutations.setResults(response.data.results.data)
          this.mutations.setTotalResults(response.data.pagination.total)
          this.pagination = this.state.pagination
          this.pagination.totalItems = response.data.pagination.total
          this.mutations.setPagination(this.pagination)
        })
    },
    goBack() {
      const routerGo = this.$route.params.routerGo;
      const routes = {
      manager: '/manager-licenses-page',
      dashboard: '/dashboard',
      default: '/licenses-manager'
      };
      const route = routes[routerGo] || routes.default;
      this.$router.push(route);
    },
  }
}
</script>

<style <style lang="scss" scoped>

::v-deep .theme--light.v-text-field--outline>.v-input__control>.v-input__slot{
  border: 2px solid rgba(105, 105, 105, 0.54);
}
::v-deep .theme--light.v-text-field--outline>.v-input__control>.v-input__slot:hover{
  border: 2px solid #4f41a3 !important;
}
.back-button:hover {
  background-color: #E0E0E0;
  border-radius: 9999px;
}

/* Estilos para modo iframe */
.iframe-mode {
  ::v-deep .theme--light.v-text-field--outline > .v-input__control > .v-input__slot:hover {
    border: 2px solid #2694fc !important;
  }
  
  ::v-deep .v-input--is-focused .v-input__slot {
    border-color: #2694fc !important;
  }
  
  ::v-deep .zt-button {
    background-color: #2694fc !important;
    border-color: #2694fc !important;
    
    &:hover {
      background-color: #1e7fd4 !important;
      border-color: #1e7fd4 !important;
    }
  }
}

.text-iframe-primary {
  color: #2694fc !important;
}
</style>